import type { DashlyControlVariant } from "./dashlyControlVariant";

export const DEFAULT_DASHLY_INPUT_DEBOUNCE_MS = 350;

export const resolveDashlyInputDebounceMs = (
    debounceMs: number | undefined,
    controlVariant: DashlyControlVariant = "form",
): number => {
    if (debounceMs !== undefined) {
        return debounceMs;
    }
    return controlVariant === "filter" ? DEFAULT_DASHLY_INPUT_DEBOUNCE_MS : 0;
};
